<template>
    <div class="input-group">
        <div class="row">
            <div class="col-md-12">
                <div>{{ compLabel }}</div>
                <label class="mr-6" v-for="(day, id) in days">
                    <input type="checkbox" class="option-input checkbox" v-model="day.checked" name="weekly_working_days[]" v-bind:value="id">
                    {{ day.name }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "WeekDaySelectMultiple",

        props: {
            weekDays: Array,
            compLabel: String,
        },

        data() {
            return {
                days: this.weekDays,
                showCategory: false,
            }
        },
    }
</script>

<style scoped>

    label{
        cursor: pointer;
    }

    .option-input {
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        -o-appearance: none;
        appearance: none;
        position: relative;
        top: 4px;
        right: 0;
        bottom: 0;
        left: 0;
        height: 20px;
        width: 20px;
        transition: all 0.05s ease-out 0s;
        background: #cbd1d8;
        border: none;
        color: #fff;
        cursor: pointer;
        display: inline-block;
        outline: none;
        position: relative;
        border-radius: 3px;
        z-index: 1000;
    }
    .option-input:hover {
        background: #9faab7;
    }
    .option-input:checked {
        background: #d97a15;
    }
    .option-input:checked::before {
        height: 20px;
        width: 20px;
        position: absolute;
        content: '✔';
        display: inline-block;
        font-size: 14px;
        text-align: center;
        line-height: 20px;
    }
    .option-input:checked::after {
        background: #40e0d0;
        content: '';
        display: block;
        position: relative;
        z-index: 100;
    }
    .option-input.radio {
        border-radius: 50%;
    }
    .option-input.radio::after {
        border-radius: 50%;
    }
</style>